import { getOrderIndices } from './get-order-indices';

/**
 * For each stop index, returns its visual order: 0 is leftmost, n-1 is rightmost.
 */
export function getOrderByStopIndex(positions) {
  const sorted = getOrderIndices(positions);
  const orderByIndex = new Array(positions.length);

  sorted.forEach((stopIndex, order) => {
    orderByIndex[stopIndex] = order;
  });

  return orderByIndex;
}
